<template>
  <div class="podcast-grid">
    <el-row
      v-if="show_heading"
      type="flex"
      justify="space-between"
      align="start"
      class="list-header">
      <h4 class="heading">{{ heading }}</h4>
    </el-row>
    <el-row
      v-if="type === 'podcast' && dataList.length"
      type="flex"
      justify="start"
      class="d-flex-wrap grid-wrapper"
      data-test="podcasts">
      <podcast-card
        v-for="index in 6"
        :key="index"
        :grid="true"
        :podcast="{uuid: index}"
        :hidden="true"
        data-test="podcast-card-hidden"/>
      <div class="flex-line-break"/>
      <podcast-card
        v-for="(item, index) in dataList"
        :key="`${item.uuid}-${index}`"
        :grid="true"
        :podcast="item"
        :episode-count="item.unseen_episodes"
        :bucket="bucket"
        data-test="podcast-card-active"/>
    </el-row>
    <el-row
      v-if="type === 'category'"
      type="flex"
      justify="center"
      class="d-flex-wrap">
      <category-card
        v-for="(item, index) in dataList"
        :key="index"
        :grid="true"
        :category="item"
        :selectable="selectable"
        :selected="item.selected"
        @onSelect="onSelectionToggle"/>
    </el-row>
  </div>
</template>
<script>
import PodcastCard from './PodcastCard';
import CategoryCard from './CategoryCard';
import User from '../services/User';
import ScrollMixin from '../shared/scrollMixin';

export default {
  components: {
    'podcast-card': PodcastCard,
    'category-card': CategoryCard,
  },
  mixins: [ScrollMixin],
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: '',
    },
    show_heading: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    bucket: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataList: [],
      userProvider: new User(),
    };
  },
  watch: {
    list(newVal) {
      if (newVal && newVal.length) {
        this.init();
        this.adjustCardsSize();
        this.adjustCardSizeWindowResize();
      }
    },
  },
  beforeMount() {
    this.parentSelector = 'podcast-grid';
    this.childSelector = '.podcast-grid .podcast-card.is-visible';
  },
  mounted() {
    this.init();
    this.adjustCardsSize();
  },
  methods: {
    init() {
      if (this.type === 'podcast') {
        this.dataList = this.list.items || this.list;
      } else {
        this.dataList = this.list;
      }
      this.contentList = this.list;
    },
    onSelectionToggle(category) {
      this.$emit('onSelect', category);
    },
    adjustCardsSize() {
      setTimeout(() => {
        const cards = document.querySelectorAll('.podcast-card.grid');
        if (cards.length) {
          const width = cards[0].clientWidth;
          // const resizeCardsLength = (cards.length > 6) ? (cards.length - 6) : (cards.length - 1);
          for (let i = (cards.length - 1); i >= 0; i--) {
            const card = cards[i];
            if (!width) return;
            card.style.maxWidth = `${width - 0.75}px`;
          }
          for (let j = 0; j < cards.length; j++) {
            const card = cards[j];
            let cardImage = card.getElementsByClassName('card-image');
            if (cardImage.length) {
              [cardImage] = cardImage;
              if (!width) return;
              cardImage.style.height = `${width}px`;
            }
          }
        }
      }, 50);
    },
    adjustCardSizeWindowResize() {
      window.addEventListener('resize', this.adjustCardsSize);
    },
  },
};
</script>
<style lang="scss">
.podcast-grid {
  .grid-wrapper {
    margin-left: -8px;
    margin-right: -8px;
    .podcast-card {
      box-sizing: border-box;
      margin-left: 0;
    }
  }

  .flex-line-break {
    flex-basis: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/PodcastGrid.vue